export default __webpack_public_path__ + "static/media/mockup4.84ebd646.png";